import { useTranslation } from 'react-i18next';

import { Button, Callout, Modal } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default function WorkspaceEditModalDanger(props: {
	workspace: graphql.Workspace;
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const [archive] = graphql.useArchiveWorkspaceMutation();

	return (
		<Modal.Contents>
			{!props.workspace.isArchived && (
				<>
					<Callout
						mb={2}
						color="danger"
						title={t('workspaces.edit.danger.archive.warning.title')}
						description={t('workspaces.edit.danger.archive.warning.description')}
					/>
					<Button
						type="destructive"
						title={t('common.archive')}
						onClick={async () => {
							await archive({ variables: { input: { workspaceID: props.workspace.id } } });
						}}
					/>
				</>
			)}
		</Modal.Contents>
	);
}
